export default __webpack_public_path__ + "static/media/intro2.cd2afed4.png";